import { EventEmitter } from 'expo-modules-core';

export const LocationEventEmitter = new EventEmitter();
